//components
import { PillLink } from '@/containers-ai/Buttons';
import { Container } from '@/components/Grid';

//styles
import {
  EndCTASection,
  Title,
  TitleHighlight,
  Copy,
  CtaRow,
} from './EndCTA.styles';

export function EndCTA({ agentName, content }) {
  return (
    <EndCTASection id="cta">
      <Container>
        <Title>
          {content.title}
          <TitleHighlight>{content.titleHighlight}</TitleHighlight>
        </Title>
        <Copy>
          {content.copyPrefix}
          {agentName}
          {content.copySuffix}
        </Copy>
        <CtaRow>
          <PillLink
            href={content.ctaHref ?? '/contact/#contact-form'}
            style={{ fontSize: '16px', padding: '16px 32px' }}
            className="qlf-btn-2"
          >
            {content.ctaLabel}
          </PillLink>
        </CtaRow>
      </Container>
    </EndCTASection>
  );
}
